// 2024-03-29
export default function getBaseConfig(initialStore, baseUrl = '/api', url = '/accessible/url/get', method = 'get') {
    return new Promise((resolve) => {
        try {
            initialStore = JSON.parse(initialStore);
            if (initialStore.data) {
                try {
                    initialStore = JSON.parse(initialStore.data);
                } catch {
                    initialStore = initialStore.data;
                }
            }
            return resolve(initialStore);
        } catch {
            let timeGap = 100;
            const request = function () {
                const xhr = new XMLHttpRequest();
                xhr.timeout = timeGap * 0.2 + 2000;
                xhr.open(method, baseUrl + url);
                xhr.onreadystatechange = function () {
                    if (xhr.readyState === 4) {
                        if ((xhr.status >= 200 && xhr.status < 300) || xhr.status === 304) {
                            var res;
                            try {
                                res = JSON.parse(xhr.response);
                                if (res.data) {
                                    try {
                                        res = JSON.parse(res.data);
                                    } catch {
                                        res = res.data;
                                    }
                                }
                            } catch {
                                res = xhr.response;
                            }
                            resolve(res);
                        } else if (xhr.status < 400 || xhr.status > 499) {
                            setTimeout(() => {
                                timeGap *= 5;
                                request();
                            }, timeGap);
                        } else {
                            resolve(xhr.response);
                        }
                    }
                };
                xhr.send(null);
            };
            request();
        }
    });
}
